import { render } from "./SurvivorSelector.vue?vue&type=template&id=1afcf05c&scoped=true"
import script from "./SurvivorSelector.vue?vue&type=script&lang=js"
export * from "./SurvivorSelector.vue?vue&type=script&lang=js"

import "./SurvivorSelector.vue?vue&type=style&index=0&id=1afcf05c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afcf05c"]])

export default __exports__